<div class="assignments-page">
  <!-- <qai-inner-wrap> -->
  <!-- HEADER -->
  <header *ngIf="!loading" class="page-header">
    <!-- Row 1: Breadcrumbs & Actions -->
    <div class="header-row-one">
      <div class="breadcrumb-container">
        <qai-breadcrumb-list
          [items]="getBreadcrumbItems()"
        ></qai-breadcrumb-list>
      </div>
    </div>

    <!-- Row 2: Tabs -->
    <div class="header-row-two">
      <qai-tabs>
        <ng-template qaiTab="uniqueId1" [label]="'simulationBuilder.ASSIGNMENT_TAB_DETAILS' | transloco">
          <tab-general-details></tab-general-details>
        </ng-template>

        <ng-template qaiTab="uniqueId2" [label]="'simulationBuilder.ASSIGNMENT_TAB_SIMULATIONS' | transloco">
          <tab-simulation-details></tab-simulation-details>
        </ng-template>

        <ng-template qaiTab="uniqueId4" [label]="'simulationBuilder.ASSIGNMENT_TAB_ASSIGNEES' | transloco">
          <tab-assigness-content></tab-assigness-content>
        </ng-template>
      </qai-tabs>
    </div>
  </header>

  <!-- Loading state -->
  <div *ngIf="loading" class="loading-container">
    <qai-loading [size]="'medium'"></qai-loading>
    <p>{{ 'simulationBuilder.LOADING_ASSIGNMENT_DETAILS' | transloco }}</p>
  </div>

  <!-- </qai-inner-wrap> -->
</div>
